<template>
  <section>
    <div class="container">

      <!-- Text content -->
      <div class="text-content">
        <h2 class="section-title">See It In Action</h2>
        <p class="section-description">
          Watch how Cookie Cutter automatically handles cookie banners for you.
          Join thousands of users worldwide who are saving time and protecting their privacy.
        </p>
      </div>

      <!-- Video -->
      <div class="video-wrapper">
        <div class="video-container">
          <iframe
            id="ytplayer"
            type="text/html"
            width="360"
            height="360"
            :src="'https://www.youtube.com/embed/' + videoID + '?autoplay=0'"
            frameborder="0"
            loading="lazy"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            title="Tutorial video for Stardust Cookie Cutter"
          ></iframe>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      videoID: "h9U0LLr-xZY"
    };
  }
};
</script>

<style scoped>
section {
  background-color: rgba(40, 54, 60, 0.7);
  backdrop-filter: blur(7px);
  filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));
  padding: 60px 20px;
  margin-bottom: 0;
  position: relative;
  z-index: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 60px;
}

.text-content {
  flex: 1;
  min-width: 300px;
  max-width: 500px;
  text-align: center;
}

.section-title {
  font-size: clamp(32px, 4.5vw, 42px);
  font-weight: 700;
  color: #e8ae1b;
  margin: 0 0 20px 0;
  line-height: 1.3;
}

.section-description {
  font-size: clamp(16px, 1.8vw, 18px);
  line-height: 1.7;
  color: rgba(254, 254, 254, 0.9);
  margin: 0;
}

.video-wrapper {
  flex: 0 0 auto;
  max-width: 400px;
  width: 100%;
}

.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

@media (max-width: 768px) {
  section {
    padding: 40px 20px;
  }

  .container {
    gap: 40px;
  }

  .video-wrapper {
    max-width: 350px;
  }
}

@media (max-width: 500px) {
  section {
    padding: 30px 16px;
  }

  .container {
    gap: 30px;
  }

  .text-content {
    min-width: auto;
  }

  .video-wrapper {
    max-width: 100%;
  }
}
</style>